import { FONT_WEIGHT } from '../../foundations/typography';
import { TextVariantType } from '../text/variants';
const before = {
    content: '',
    display: 'block',
    width: '50%',
    height: '50%',
    border_radius: '100%',
    transform: 'translate(50%, 50%)',
};
export const commonStyles = (FOUNDATIONS, STATE_TOKENS) => ({
    container: {
        display: 'flex',
        flex_direction: 'column',
        border_radius: FOUNDATIONS.radius_comp_assistedchanels_selectorcardoperative_radiussize,
        padding: FOUNDATIONS.spacing_150,
        border_style: 'solid',
        ...STATE_TOKENS.container,
    },
    header: {
        display: 'flex',
        justify_content: 'space-between',
        gap: FOUNDATIONS.spacing_150,
        padding_bottom: FOUNDATIONS.spacing_150,
        ...STATE_TOKENS.header,
    },
    headerLeft: {
        height: '100%',
        display: 'flex',
        align_items: 'flex-start',
        flex: 1,
        ...STATE_TOKENS.headerLeft,
    },
    headerRight: {
        display: 'flex',
        gap: FOUNDATIONS.spacing_150,
        ...STATE_TOKENS.headerRight,
    },
    radio: {
        width: FOUNDATIONS.size_300,
        height: FOUNDATIONS.size_300,
        border_radius: FOUNDATIONS.radius_1000,
        border_style: 'solid',
        ...STATE_TOKENS.radio,
        before: {
            ...before,
            ...STATE_TOKENS?.radio?.before,
        },
    },
    content: {
        display: 'flex',
        flex_direction: 'column',
        align_items: 'flex-start',
        ...STATE_TOKENS.content,
    },
    tagsContainer: {
        display: 'flex',
        width: '100%',
        align_items: 'center',
        justify_content: 'center',
        padding_top: FOUNDATIONS.spacing_150,
        gap: FOUNDATIONS.spacing_150,
        ...STATE_TOKENS.tagsContainer,
    },
    label: {
        font_variant: TextVariantType.FONT_PARAGRAPH_500,
        color: FOUNDATIONS.color_neutral_font_50,
        font_weight: FONT_WEIGHT.font_regular,
        ...STATE_TOKENS.label,
    },
    title: {
        font_variant: TextVariantType.FONT_PARAGRAPH_250,
        color: FOUNDATIONS.color_neutral_font_50,
        font_weight: FONT_WEIGHT.font_bold,
        ...STATE_TOKENS.title,
    },
    teller: {
        font_variant: TextVariantType.FONT_PARAGRAPH_350,
        color: FOUNDATIONS.color_neutral_font_50,
        font_weight: FONT_WEIGHT.font_regular,
        ...STATE_TOKENS.teller,
    },
});
//# sourceMappingURL=commonStyles.js.map